module.exports = __webpack_public_path__ + "img/fixit-logo-white.199ad42.png";